import React, { memo } from 'react';
import MenuServiceLoader from '@signal/core/menuService/Loader';
import { ActiveAccountContext } from '@signal/core/user/Context';
import UserLoader from '@signal/core/user/Loader';
import renderIf from '@signal/utils/renderIf';
import { getColorSecondarySelector } from '@signal/theme/selectors';
import { useTheme } from '@material-ui/core/styles';

var getMenuPanelIconColor = function getMenuPanelIconColor(theme) {
  return getColorSecondarySelector('dark')(theme);
};

export function CommonPageLoader(_ref) {
  var accountId = _ref.accountId,
      baseUrl = _ref.baseUrl,
      children = _ref.children,
      onAccountChange = _ref.onAccountChange;
  var theme = useTheme();
  return /*#__PURE__*/React.createElement(UserLoader, {
    accountId: accountId,
    onAccountChange: onAccountChange
  }, /*#__PURE__*/React.createElement(ActiveAccountContext.Consumer, null, function (_ref2) {
    var activeAccount = _ref2.activeAccount;
    return renderIf(Boolean(accountId || activeAccount), function () {
      return /*#__PURE__*/React.createElement(MenuServiceLoader, {
        iconProps: {
          fill: getMenuPanelIconColor(theme)
        },
        accountId: accountId || activeAccount && activeAccount.accountId,
        baseUrl: baseUrl
      }, children);
    }, function () {
      return children;
    });
  }));
}
export default /*#__PURE__*/memo(CommonPageLoader);